import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroContactRequestForm.ContactInformationPart', {
    title: 'Contact Information',
    contactName: 'Contact name',
    contactNamePlaceholder: 'Enter Contact name',
    accountNumber: 'Account number',
    accountNumberPlaceholder: 'Enter Account number',
    primaryPersonFirstName: 'Primary person first name',
    primaryPersonFirstNamePlaceholder: 'Enter Primary person first name',
    primaryPersonLastName: 'Primary person last name',
    primaryPersonLastNamePlaceholder: 'Enter Primary person last name',
    addAnotherPerson: 'Add another person',
    anotherPersonTitle: 'Another person {index}',
    remove: 'Remove',
    firstName: 'First name',
    firstNamePlaceholder: 'Enter First name',
    lastName: 'Last name',
    lastNamePlaceholder: 'Enter Last name',
    email: 'Email',
    emailPlaceholder: 'Enter Email',
    phoneLabel: 'Phone',
    faxLabel: 'Fax',
    mobileLabel: 'Mobile',
    directDialLabel: 'Direct dial',
    skypeNameLabel: 'Skype name/number',
    skypeNamePlaceholder: 'Enter Skype name/number',
    websiteLabel: 'Website',
    websitePlaceholder: 'Ex: https://approvalmax.com',
});
